import { createStyles } from "src/styles/theme";

export type StylesClasses = keyof typeof styles;

const styles = createStyles({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100%",
    padding: {
      xs: "20px",
      sm: "28px",
    },
    boxSizing: "border-box",
    backgroundImage: "url('/assets/images/logInBackground.jpeg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
  contentWrapper: {
    width: "100%",
    maxWidth: "1344px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "stretch",
    gap: "24px",
    "@media (max-width: 1099px)": {
      flexDirection: "column",
      alignItems: "center",
    },
  },

  logInWrapper: {
    width: "100%",
    maxWidth: "500px",
    flexShrink: 0,
    height: "auto",
    borderRadius: "24px",
    padding: "28px 34px",
    boxSizing: "border-box",
    position: "relative",
    backgroundColor: "white",
  },
  meetingWrapper: {
    width: "100%",
    maxWidth: "820px",
    minWidth: 0,
    display: "flex",
    flex: "1 1 0",
  },
  noAccount: {
    fontSize: "15px",
    fontWeight: 600,
    color: "#8D8D8D",
    whiteSpace: "nowrap",
    textAlign: "center",
  },

  signUp: {
    color: "custom.text.label",
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
  },

  welcomeBox: {
    display: "flex",
    justifyContent: "center",
  },
  accountBox: {
    display: "flex",
    flexDirection: "column",
    width: "80px",
  },

  logo: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "1%",
    marginBottom: "20px",
  },

  welcome: {
    fontSize: "21px",
    fontWeight: 400,
  },
  welcomeSpan: {
    fontSize: "21px",
    fontWeight: 600,
    color: "#779341",
  },
  title: {
    color: "primary.main",
    fontFamily: "Inter",
    fontSize: "22px",
    fontWeight: 600,
  },
  heading: {
    fontSize: "50px",
    fontWeight: 600,
    marginBottom: "16px",
  },

  loginFields: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    margin: "16px 0px 20px 0px",
  },

  forgetPassword: {
    position: "absolute",
    cursor: "pointer",
    right: "35px",
    color: "custom.text.label",
  },
  logInBtn: {
    marginTop: "35px",
  },
  input: {},
  password: {},
  loginBtn: {
    width: "206px",
    height: "44px",
    margin: "auto",
  },
});

export default styles;
